import React from "react";
import PropTypes from "prop-types";
// material ui core
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

// Custom components
import { Dashboard as DashboardLayout } from "../../../../layouts/";
// Styles
import { withStyles } from "@material-ui/core/styles";
import QRCode from "qrcode.react";
import TooltipToggleButton from "../../../../components/Tooltip/tooltipToggleButtons";
import _ from "lodash";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// https://restcountries.eu/rest/v2/all?fields=name;alpha2Code
import { countries } from "./countries";
import { states } from "./states";
import {
  fetchSubscriptionEstimate,
  fetchPaymentIntentCreate,
  fetchSubscriptionCreate,
  clearSubscriptionEstimate,
  clearTransactionInfo,
  fetchLicenses,
  clearLicensesInfo
} from "../../../../redux/actions/subscriptionActions";
import { pushMessage } from "../../../../redux/actions/commonActions";
import validation from "./validation";

// Test Snackbar
import OrderSummaryComponent from "../OrderSummary";
import BasketFormComponent from "../Basket/basketForm";
import SubscriptionInfoComponent from "../SubscriptionInfo";
import BillingInfoComponent from "../BillingInfo";
import CreditCardInfoComponent from "../CreditCardInfo";
import subscriptionCommon from "./common";
import basketUtil from "./basket";
import { setDisplayName } from "recompose";
import CountersInfo from "../SubscriptionInfo/countersInfo";
import authorization from "./authorization";

// Site config
import {getEnvironmentName} from "../../../../utils"
const environment = getEnvironmentName()
const config = require("../../../../app_configuration").CONFIGURATION[environment];

const calcDepandsOn = [
  // Billing
  "billing_zip",
  "billing_country",
  "billing_state_code",
  "billing_state",
  // Basket
  "numberOfLicences",
  "deployTheBot",
  "numberOfLicences",
  "addNumberOfLicences",
  "billOption"
];
// const paymentIntentRequired = ["billing_zip", "billing_country", "numberOfLicences", "deployTheBot"];
const requiredCreditCard = ["cardFirstName", "cardLastName", "cardNumber", "cardExpMonth", "cardExpYear", "cardCVV"];
const requiredBilling = [];
const initBillOption = () => {
  var urlParams = new URLSearchParams(window.location.search);
  let isAnnual = undefined;
  if (urlParams.has("annual")); // true
  {
    isAnnual = urlParams.get("annual") === "0";
  }
  if (isAnnual) return "annualy";
  return "monthly";
};

const initState = {
  // Subscription options
  numberOfLicences: 1,
  addNumberOfLicences: 0,
  deployTheBot: false,
  licensesEvaluated: false,
  billOption: initBillOption(),

  // Payment information
  cardFirstName: "",
  cardLastName: "",
  cardNumber: "",
  cardExpMonth: "",
  cardExpYear: "",
  cardCVV: "",

  // // From user profile
  // first_name: "",
  // last_name: "",
  // company_name: "",
  // phone_number: "",
  // email: "",

  // Billing
  billing_address_line_1: "",
  billing_city: "",
  billing_zip: "",
  billing_country: "",
  billing_state_code: "",
  billing_state: "",

  // UI
  collapsed: {},
  timestamp: Date.now(),

  required: [
    "billing_zip",
    "billing_first_name",
    "billing_last_name",
    "numberOfLicences",
    "deployTheBot",
    "billOption",
    "cardName",
    "cardNumber",
    "expDate",
    "cvv",
    "first_name",
    "last_name",
    "title",
    "company_name",
    "phone_number"
  ],

  // Chargebee
  cbInstance: window.Chargebee.init({
    site: config.CHARGEBEE_SITE
  }),

  enableValidators: false,
  transactionInProcess: false
};

class Subscription extends React.Component {
  state = { ...initState };

  processLicenses = licenseData => {
    const retVal = {};
    const licenses = licenseData.licenses.Items;
    const resources = licenseData.resources.Items;

    // Counters by subscription
    let counters = [];
    _.map(licenses, item => {
      _.map(item.counters, (counter, counter_code) => {
        counters.push({
          plan_code: item.plan_code,
          code: counter_code,
          counterLimit: counter.counterLimit,
          limit: counter.limit,
          counter: counter.counter
        });
      });
    });

    const licenseSum = {};
    _.map(_.groupBy(counters, "code"), (objs, key) => {
      if (!licenseSum[key]) licenseSum[key] = {};
      _.map(_.groupBy(objs, "plan_code"), (objs2, key2) => {
        const sum1 = _.sumBy(objs2, "counterLimit");
        const sum2 = _.sumBy(objs2, "limit");
        const sum3 = _.sumBy(objs2, "counter");
        if (!licenseSum[key][key2]) licenseSum[key][key2] = { counterLimitSum: sum1, limitSum: sum2, counterSum: sum3 };
        else {
          licenseSum[key][key2].counterLimitSum += sum1;
          licenseSum[key][key2].limitSum += sum2;
          licenseSum[key][key2].counterSum += sum3;
        }
      });
    });

    // Create free license (if not created)
    if (!licenseSum.users) licenseSum.users = {};
    if (!licenseSum.users.starter) licenseSum.users.starter = { counterLimitSum: 25, limitSum: 25, counterSum: 0 };

    console.log("State Licenses:", licenseSum);
    retVal.licenses = licenseSum;

    // resources sum
    const resourcesSum = {};
    _.map(licenseSum, (codes, key) => {
      _.map(codes, (x, key2) => {
        if (!resourcesSum[key]) {
          resourcesSum[key] = { [key2]: { counterSum: 0 } };
        } else {
          resourcesSum[key][key2] = { counterSum: 0 };
        }
      });
    });

    // Load resources
    _.map(resources, resource => {
      console.log("Loading resource", resource.tenant, resource.user);
      _.map(resource.counters, (part1, code) => {
        _.map(part1, (counter, plan_code) => {
          console.log("Loading resource counter", counter);
          if (!resourcesSum[code]) resourcesSum[code] = {};
          if (!resourcesSum[code][plan_code]) resourcesSum[code][plan_code] = { counterSum: counter.counter };
          else {
            resourcesSum[code][plan_code].counterSum += counter.counter;
          }
        });
      });
    });
    retVal.resourcesSum = resourcesSum;
    console.log("State Resources Sum:", resourcesSum);

    // resources by User
    const usersResources = {};
    _.map(resources, resource => {
      if (!usersResources[resource.user]) usersResources[resource.user] = {};

      _.map(resource.counters, (part1, code) => {
        _.map(part1, (counter, plan_code) => {
          if (!usersResources[resource.user][code]) usersResources[resource.user][code] = {};
          if (!usersResources[resource.user][code][plan_code])
            usersResources[resource.user][code][plan_code] = { counterSum: counter.counter };
          else {
            usersResources[resource.user][code][plan_code].counterSum += counter.counter;
          }
        });
      });
    });

    retVal.usersResources = usersResources;
    console.log("State User Resources:", usersResources);

    // popis licenci za prikazati
    const showList = [];
    _.map(licenseSum.users, (lic, key) => {
      console.log("KEY", key);
      console.log("LIC", lic);
      let sumToCheck = lic.counterLimitSum;
      if (!sumToCheck) sumToCheck = lic.limitSum;

      if (sumToCheck > 0 && (!resourcesSum.users[key] || resourcesSum.users[key].counterSum < sumToCheck))
        showList.push({ key: key, value: key });
    });
    retVal.licensesAvailable = showList;
    console.log("State Licenses Available:", showList);
    return retVal;
  };

  selectSubscription = () => {
    const { subscriptions } = this.props;
    var urlParams = new URLSearchParams(window.location.search);
    let planId = "pro";

    if (this.state.licensesAvailable && this.state.licensesAvailable.find(x => x.key === "business")) {
      planId = "business";
    }
    if (urlParams.has("plan")); // true
    {
      const readParam = urlParams.get("plan");
      if (readParam && readParam.trim() !== "") planId = readParam;
    }
    const found = _.filter(subscriptions, item => {
      if (!item.plan.id.startsWith(planId)) return false;
      if (this.state.billOption === "monthly" && item.plan.period_unit !== "month") return false;
      if (this.state.billOption === "annualy" && item.plan.period_unit !== "year") return false;
      return true;
    });
    if (!found[0]) {
      return { plan: { name: "", qty: "" } };
    }
    return found[0];
  };

  handleChange = e => {
    const ccValid = validation.cc_number_format(this.state.cardNumber);

    if (!e.target.value && !this.state.required.includes(e.target.id)) {
      this.setState({
        [e.target.id]: " ",
        timestamp: Date.now()
      });
    } else {
      this.setState({
        [e.target.id]: e.target.value,
        timestamp: Date.now()
      });
    }
    if (!this.props.estimate.estimate || calcDepandsOn.includes(e.target.id)) this.scheduleEstimate();
    // if (paymentIntentRequired.includes(e.target.id))
    //     this.schedulePaymentIntentCreate();
  };

  handleChangeCountry = e => {
    let countryName = _.find(countries, x => {
      return x.alpha2Code === e.target.value;
    }).name;
    if (!e.target.value && !this.state.required.includes(e.target.id)) {
      this.setState({
        [e.target.id]: " ",
        billing_country_name: countryName,
        billing_state: "",
        billing_state_code: "",
        timestamp: Date.now()
      });
    } else {
      this.setState({
        [e.target.id]: e.target.value.trim(),
        billing_country_name: countryName,
        billing_state: "",
        billing_state_code: "",
        timestamp: Date.now()
      });
    }
    if (!this.props.estimate.estimate || calcDepandsOn.includes(e.target.id)) this.scheduleEstimate();
    // if (paymentIntentRequired.includes(e.target.id))
    //     this.schedulePaymentIntentCreate();
  };

  handleChangeState = e => {
    let stateName = states[this.state.billing_country][e.target.id]
      ? states[this.state.billing_country][e.target.id]
      : " ";
    if (!e.target.value && !this.state.required.includes(e.target.id)) {
      this.setState({
        [e.target.id]: " ",
        ["billing_state"]: stateName,
        timestamp: Date.now()
      });
    } else {
      this.setState({
        [e.target.id]: e.target.value.trim(),
        ["billing_state"]: stateName,
        timestamp: Date.now()
      });
    }
    if (!this.props.estimate.estimate || calcDepandsOn.includes(e.target.id)) this.scheduleEstimate();
    // if (paymentIntentRequired.includes(e.target.id))
    //     this.schedulePaymentIntentCreate();
  };

  handleCheckboxChange = e => {
    this.setState({
      [e.target.id]: e.target.checked,
      timestamp: Date.now()
    });
    if (calcDepandsOn.includes(e.target.id)) this.scheduleEstimate();
    // if (paymentIntentRequired.includes(e.target.id))
    //     this.schedulePaymentIntentCreate();
  };

  handleBillPeriodChange = e => {
    e.preventDefault();
    this.setState(oldState => {
      return { billOption: oldState.billOption === "monthly" ? "annualy" : "monthly", timestamp: Date.now() };
    });
    this.scheduleEstimate();
    this.schedulePaymentIntentCreate();
  };

  async getEstimate() {
    try {
      if (this.validateBillingInfo()) {
        const catalog = this.getCatalog();

        const fiksedUserLicences = basketUtil.getFiksedLicenses(catalog, this.state.deployTheBot, this.state.licenses);
        var addLicences = 0;
        if (!this.state.deployTheBot) {
          if (fiksedUserLicences < this.state.numberOfLicences)
            addLicences = this.state.numberOfLicences - fiksedUserLicences;
        } else {
          if (this.state.addNumberOfLicences > 0) addLicences = this.state.addNumberOfLicences;
        }

        const mainItem = basketUtil.getMainItem(catalog);
        console.log("this.state.licenses", this.state.licenses);
        const addonItems = basketUtil.getAddonItems(catalog, addLicences, this.state.deployTheBot, this.state.licenses);
        const subs = { plan: catalog.plan };

        const data = {
          method: "estimate_create_subsription",
          params: {
            billing_address: {
              line1: this.state.billing_address_line_1.trim(),
              city: this.state.billing_city.trim(),
              state_code: this.state.billing_state_code.trim(),
              zip: this.state.billing_zip.trim(),
              country: this.state.billing_country.trim() // Country code
              // zip: this.state.billing_zip,
              // country: this.state.billing_country
            },
            subscription: {
              plan_id: subs.plan.id
              // plan_quantity: this.state.numberOfLicences
            },
            addons: _.map(addonItems, item => ({
              id: item.id,
              quantity: item.count
            }))
          }
        };
        this.setState({ isLoading: true });
        const dispatchMessage = await this.props.fetchSubscriptionEstimate(data);
        this.setState({ isLoading: false });
        if (!dispatchMessage.payload.estimateError) {
          this.schedulePaymentIntentCreate();
        } else {
          this.props.pushMessage({
            type: "info",
            message: "Please check form details ...",
            preventDuplicate: true
          });
          if (this.props.estimate.estimate) this.props.clearSubscriptionEstimate();
        }
      } else {
        if (this.props.estimate.estimate) this.props.clearSubscriptionEstimate();
      }
    } catch (error) {
      if (this.signal) {
        this.setState({
          isLoading: false,
          error
        });
      }
    }
  }

  callUpdateEstimate = () => {
    this.props.clearSubscriptionEstimate();
    return setTimeout(() => {
      const current = Date.now();
      if (current - this.state.timestamp > 2000) {
        this.setState({ estimateRunning: false });
        this.getEstimate();
      } else {
        this.callUpdateEstimate();
      }
    }, 1000);
  };

  scheduleEstimate = () => {
    this.setState(oldState => {
      if (oldState.estimateRunning) {
        return {};
      } else {
        this.callUpdateEstimate();
        return { estimateRunning: true };
      }
    });
  };

  async getSubscriptionCreate(card) {
    try {
      const catalog = this.getCatalog();
      const fiksedUserLicences = basketUtil.getFiksedLicenses(catalog, this.state.deployTheBot, this.state.licenses);
      var addLicences = 0;
      if (!this.state.deployTheBot) {
        if (fiksedUserLicences < this.state.numberOfLicences)
          addLicences = this.state.numberOfLicences - fiksedUserLicences;
      } else {
        if (this.state.addNumberOfLicences > 0) addLicences = this.state.addNumberOfLicences;
      }

      const mainItem = basketUtil.getMainItem(catalog);
      const addonItems = basketUtil.getAddonItems(catalog, addLicences, this.state.deployTheBot, this.state.licenses);
      const subs = { plan: catalog.plan };

      const data = {
        method: "subscription_create",
        params: {
          plan_id: subs.plan.id,
          auto_collection: "off",
          billing_address: {
            first_name: this.state.billing_first_name.trim(),
            last_name: this.state.billing_last_name.trim(),
            line1: this.state.billing_address_line_1.trim(),
            city: this.state.billing_city.trim(),
            // state: this.state.billing_state.trim(),
            state_code: this.state.billing_state_code.trim(),
            zip: this.state.billing_zip.trim(),
            country: this.state.billing_country.trim(), // Country code
            phone: this.state.billing_phone_number,
            email: this.state.billing_email
          },
          customer: {
            first_name: this.state.first_name.trim(),
            last_name: this.state.last_name.trim(),
            email: this.state.email.trim(),
            company: this.state.company_name.trim(),
            phone: this.state.phone_number.trim()
          },
          addons: _.map(addonItems, item => ({
            id: item.id,
            quantity: item.count
          }))
        }
      };

      if (this.props.payment_intent.payment_intent.id) {
        data.params.payment_intent = {
          id: this.props.payment_intent.payment_intent.id
        };
      } else {
        if (card) {
          data.params.card = card;
        } else {
          data.params.card = { error: "missing" };
        }
      }

      this.props.pushMessage({
        type: "info",
        message: "Creating subscription, please wait ...",
        preventDuplicate: true
      });
      this.setState({ isLoading: true });
      this.setState({ ...initState, transactionInProcess: true });
      await this.props.fetchSubscriptionCreate(data);
      this.props.clearSubscriptionEstimate();
      this.setState({ isLoading: false });
      this.setState({ licensesEvaluated: false });
    } catch (error) {
      this.setState({ transactionInProcess: false });
      if (this.signal) {
        this.setState({
          isLoading: false,
          error
        });
      }
    }
  }

  async getPaymentIntentCreate() {
    try {
      if (this.props.estimate.estimate) {
        const data = {
          method: "payment_intent_create",
          params: {
            amount: this.props.estimate.estimate.invoice_estimate.total,
            currency_code: "USD"
          }
        };
        this.setState({ isLoading: true });
        await this.props.fetchPaymentIntentCreate(data);
        this.setState({ isLoading: false });
      } else {
      }
    } catch (error) {
      if (this.signal) {
        this.setState({
          isLoading: false,
          error
        });
      }
    }
  }

  callPaymentIntentCreate = () => {
    return setTimeout(() => {
      const current = Date.now();
      if (current - this.state.timestamp > 2000) {
        this.setState({ paymentIntentCreateRunning: false });
        this.getPaymentIntentCreate();
      } else {
        this.callPaymentIntentCreate();
      }
    }, 1000);
  };

  schedulePaymentIntentCreate = () => {
    this.setState(oldState => {
      if (oldState.paymentIntentCreateRunning) {
        return {};
      } else {
        this.callPaymentIntentCreate();
        return { paymentIntentCreateRunning: true };
      }
    });
  };

  componentWillMount() {
    this.signal = true;
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.license.license) {
      const data = this.processLicenses(nextProps.license.license);
      console.log("PROCESS_LICENSES", data);
      let plan_code = "pro";
      if (this.state.licensesAvailable && this.state.licensesAvailable.find(x => x.key === "business")) {
        plan_code = "business";
      }
      var urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has("plan") && ["pro", "business"].includes(urlParams.get("plan"))) {
        plan_code = urlParams.get("plan"); // "edit"
      }
      if (
        !this.state.licensesEvaluated &&
        data.licenses &&
        data.licenses.users &&
        data.licenses.users[plan_code] &&
        data.licenses.users[plan_code].limitSum >= 10 &&
        data.licenses.chatbot &&
        data.licenses.chatbot[plan_code] &&
        data.licenses.chatbot[plan_code].limitSum > 0
      ) {
        console.log("Mark deployTheBot");
        this.setState({ ...data, deployTheBot: true, licensesEvaluated: true });
      } else {
        this.setState({ ...data, licensesEvaluated: true });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (prevProps.subscriptions.length === 0 || !prevProps.addons.addons) &&
      this.props.subscriptions.length > 0 &&
      this.props.addons.addons
    ) {
      this.scheduleEstimate();
    }

    if (prevProps.estimate.estimate && !this.props.estimate.estimate) {
      this.scheduleEstimate();
    }

    if (!prevProps.transaction && this.props.transaction && this.state.transactionInProcess) {
      if (this.props.transaction.transaction.subscription && this.props.transaction.transaction.customer) {
        this.props.pushMessage({
          type: "success",
          message: "Subscription created successfuly",
          preventDuplicate: true
        });
      } else {
        this.props.pushMessage({ type: "error", message: "Subscription creation failed", preventDuplicate: true });
      }
      this.props.clearTransactionInfo();
      this.fetchLicenses();
    }

    if (prevProps.transaction && !this.props.transaction) {
      this.setState({ transactionInProcess: false });
    }
  }

  fetchLicenses() {
    const data = {
      method: "license_list",
      params: {}
    };
    this.props.fetchLicenses(data);
  }

  componentDidMount() {
    this.fetchLicenses();
    const given_name = this.props.cognitoUser.attributes.given_name;
    const last_name = this.props.cognitoUser.attributes.family_name;
    const company_name = _.get(this.props.cognitoUser.attributes, "custom:company_name");
    const phone_number = this.props.cognitoUser.attributes.phone_number;
    const addres1 = this.props.cognitoUser.attributes.addres1;
    const addres2 = this.props.cognitoUser.attributes.addres2;
    const addres3 = this.props.cognitoUser.attributes.addres3;
    const city = this.props.cognitoUser.attributes.city;
    const zip = this.props.cognitoUser.attributes.zip;
    const state = this.props.cognitoUser.attributes.state;
    const stateCode = this.props.cognitoUser.attributes.stateCode;
    const country = this.props.cognitoUser.attributes.country;
    const email = this.props.cognitoUser.attributes.email;

    const newstate = {
      first_name: given_name ? given_name : "",
      last_name: last_name ? last_name : "",
      company_name: company_name ? company_name : "",
      phone_number: phone_number ? phone_number : "",
      email: email ? email : "",
      billing_first_name: given_name ? given_name : "",
      billing_last_name: last_name ? last_name : "",
      billing_company_name: company_name ? company_name : "",
      billing_phone_number: phone_number ? phone_number : "",
      billing_email: email ? email : "",
      billing_country: country ? country : "US",
      billing_address_line_1: addres1 ? addres1 : "",
      billing_address_line_2: addres2 ? addres2 : "",
      billing_address_line_3: addres3 ? addres3 : "",
      billing_city: city ? city : "",
      billing_zip: zip ? zip : "",
      billing_state: state ? state : "",
      billing_state_code: stateCode ? stateCode : ""
    };

    this.setState(newstate);
  }

  toggleConnectors = part => () => {
    this.setState(oldState => {
      const newState = { ...oldState };
      if (oldState.collapsed[part] !== undefined) newState.collapsed[part] = !oldState.collapsed[part];
      else newState.collapsed[part] = true;
      return newState;
    });
  };

  validateCreaditCardInfo() {
    if (requiredCreditCard.length === 0) return true;
    const isValid = _.every(requiredCreditCard, x => this.state[x]);
    return isValid;
  }

  validateBillingInfo() {
    if (requiredBilling.length === 0) return true;
    const isValid = _.every(requiredBilling, x => this.state[x]);
    return isValid;
  }

  onSubscribeClick = event => {
    event.preventDefault();
    let paymentIntent = this.props.payment_intent.payment_intent;
    let paymentEstimate = this.props.estimate.estimate;
    if (!paymentIntent || !paymentEstimate || !this.validateBillingInfo()) {
      this.props.pushMessage({
        type: "warning",
        message: "Please complete your billing information",
        preventDuplicate: true
      });
      this.setState({
        enableValidators: true
      });
      return;
    }
    if (!this.validateCreaditCardInfo()) {
      this.props.pushMessage({
        type: "warning",
        message: "Please complete your Credit Card Information",
        preventDuplicate: true
      });
      this.setState({
        enableValidators: true
      });
      return;
    }

    // creditCard
    const card = {
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      number: this.state.cardNumber,
      expiry_month: this.state.cardExpMonth,
      expiry_year: this.state.cardExpYear,
      cvv: this.state.cardCVV
    };

    if (paymentIntent.id) {
      // create 3DS instance
      this.state.cbInstance
        .load3DSHandler()
        .then(threeDS => {
          // Set intent
          threeDS.setPaymentIntent(paymentIntent);

          // Handle verification
          threeDS
            .handleCardPayment(
              {
                card: {
                  firstName: this.state.first_name,
                  lastName: this.state.last_name,
                  number: this.state.cardNumber,
                  cvv: this.state.cardCVV,
                  expiryMonth: this.state.cardExpMonth,
                  expiryYear: this.state.cardExpYear
                },
                additionalData: {}
              },
              {
                change: function(intent) {
                  // Triggers on each step transition
                },
                success: function(intent) {
                  // Triggers when card is 3DS authorized
                  // After a 3DS flow is completed, the paymentIntent returned will be in authorized state
                  // You can use this paymentIntent id for creating a subscription, adding a payment source, for collecting payment of an unpaid invoice that was failed due to 3DS.
                  // this.props.pushMessage({ type: "info", message: "Credit Card Authentication Success", preventDuplicate: true });
                },
                error: function(intent, error) {
                  // Triggers when 3DS authorization fails
                  // this.props.pushMessage({ type: "error", message: "Credit Card Authentication Failure", preventDuplicate: true });
                  // console.log("3DS ERROR", error);
                }
              }
            )
            .then(paymentIntent => {
              const s = `Payment is ${paymentIntent.status}`;
              this.setState({ paymentStatus: s });
              this.getSubscriptionCreate(card);
            })
            .catch(error => {
              const s = `Failed to Authorize: ` + error;
              this.props.pushMessage({ type: "error", message: s, preventDuplicate: true }); // Error
              this.setState({ paymentStatus: s, enableValidators: true });
            });
          return "";
        })
        .catch(err => {
          this.props.pushMessage({ type: "error", message: err, preventDuplicate: true }); // Error
          this.setState({
            enableValidators: true
          });
        });
    } else {
      // Skipp 3DS
      this.getSubscriptionCreate(card);
    }
  };

  getCatalog() {
    let catalog = { plan: {}, addons: [] };
    if (this.props.plans && this.props.addons && this.props.plans !== {} && this.props.plans.length !== 0) {
      const useChatbot = true;
      const licences = 1;
      const period = this.state.billOption === "monthly" ? "month" : "year";
      let plan_code = "pro";
      var urlParams = new URLSearchParams(window.location.search);
      if (this.state.licensesAvailable && this.state.licensesAvailable.find(x => x.key === "business")) {
        plan_code = "business";
      }
      if (urlParams.has("plan") && ["pro", "business"].includes(urlParams.get("plan"))) {
        plan_code = urlParams.get("plan"); // "edit"
      }
      catalog = basketUtil.createCatalog(
        this.props.plans,
        this.props.addons,
        useChatbot,
        licences,
        period,
        plan_code,
        this.state.licenses
      );
    }
    return catalog;
  }

  render() {
    const { classes } = this.props;
    const subs = this.selectSubscription(); // { plan: { name: "", qty: "" } }; //=

    const catalog = this.getCatalog();

    let paymentIntent = this.props.payment_intent.payment_intent;
    let paymentEstimate = this.props.estimate.estimate;
    const enableSubmit = paymentIntent !== undefined && paymentEstimate !== undefined;
    return (
      <DashboardLayout title="Profile">
        <Grid container spacing={5}>
          <Grid item lg={8} xs={12} md={6}>
            <Paper className={classes.root} elevation={1}>
              <CountersInfo />
              <br />
              <Typography variant="h3" component="h3">
                Purchase licenses
              </Typography>
              <Typography style={{ paddingTop: "10px" }} />
              <br />
              <br />
              <br />
              <br />
              <BasketFormComponent
                basket={catalog}
                subs={subs}
                orderState={this.state}
                classes={classes}
                handleCheckboxChange={this.handleCheckboxChange}
                handleChange={this.handleChange}
              />
              <br />
              <br />
              <br />
              <br />
              <BillingInfoComponent
                basket={catalog}
                orderState={this.state}
                classes={classes}
                handleChange={this.handleChange}
                handleChangeCountry={this.handleChangeCountry}
                handleChangeState={this.handleChangeState}
                toggleConnectors={this.toggleConnectors}
              >
                {" "}
              </BillingInfoComponent>
              <br />
              <br />
              <br />
              <br />
              <CreditCardInfoComponent
                basket={catalog}
                orderState={this.state}
                classes={classes}
                handleChange={this.handleChange}
                toggleConnectors={this.toggleConnectors}
              />
              <br />
              <br />
              <br />
              <br />
            </Paper>
          </Grid>
          <Grid item lg={4} xs={12} md={6}>
            <Paper className={classes.root} elevation={1}>
              {/* {this.OrderSummary()} */}
              <OrderSummaryComponent
                enableSubmit={enableSubmit}
                basket={catalog}
                orderState={this.state}
                classes={classes}
                subs={subs}
                estimate={this.props.estimate}
                onSubscribeClick={this.onSubscribeClick}
                handleBillPeriodChange={this.handleBillPeriodChange}
              />
            </Paper>
          </Grid>
        </Grid>
      </DashboardLayout>
    );
  }
}

Subscription.propTypes = {
  cognitoUser: PropTypes.object,
  fetchSubscriptionEstimate: PropTypes.func,
  fetchPaymentIntentCreate: PropTypes.func,
  fetchSubscriptionCreate: PropTypes.func,
  pushMessage: PropTypes.func,
  clearSubscriptionEstimate: PropTypes.func,
  clearTransactionInfo: PropTypes.func,
  fetchLicenses: PropTypes.func,
  clearLicensesInfo: PropTypes.func
};

function mapStateToProps(state) {
  return {
    cognitoUser: state.auth.cognitoUser
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        fetchSubscriptionEstimate,
        fetchPaymentIntentCreate,
        fetchSubscriptionCreate,
        clearSubscriptionEstimate,
        clearTransactionInfo,
        fetchLicenses,
        clearLicensesInfo,
        pushMessage
      },
      dispatch
    ),
    dispatch
  };
}

Subscription = connect(
  mapStateToProps,
  mapDispatchToProps
)(Subscription);

export default withStyles(subscriptionCommon.styles)(Subscription);
